import { connect } from 'react-redux'
import { compose, lifecycle } from 'recompose'
import { getUserCharity } from './selectors'
import { getUserCharityId } from '../session'
import { fetchCharity } from './actions'
import { isCommCompleted, isCommInProgress } from '../../modules/communication'
import { RESOURCES } from './constants'
import withLoadingUntilFn from '../../core/withLoadingUntilFn'

function mapStateToProps(state) {
  return {
    userCharityId: getUserCharityId(state),
    charity: getUserCharity(state),
    isCharityLoaded: isCommCompleted(RESOURCES.FETCH_CHARITY, state),
    isCharityLoading: isCommInProgress(RESOURCES.FETCH_CHARITY, state)
  }
}

const withDataAndActions = connect(mapStateToProps, {
  fetchCharity
})

const fetchOnMountIfNeeded = lifecycle({
  fetchIfNeeded() {
    const {
      userCharityId,
      charity,
      isCharityLoading,
      fetchCharity
    } = this.props
    if (userCharityId && !charity && !isCharityLoading) {
      fetchCharity()
    }
  },
  componentDidMount() {
    this.fetchIfNeeded()
  },
  componentDidUpdate() {
    this.fetchIfNeeded()
  }
})

export const decorator = compose(
  withDataAndActions,
  fetchOnMountIfNeeded,
  withLoadingUntilFn(props => {
    return props.isCharityLoading
  })
)
export default decorator



// WEBPACK FOOTER //
// ./src/services/register-charity/withUserCharityData.js